import { EventTypes } from 'redux-segment';

const SET_USERDATA = 'formlabs/auth/SET_USERDATA';
const SET_IS_AUTHENTICATED = 'formlabs/auth/SET_IS_AUTHENTICATED';

const initialState = {
  username: null,
  firstName: null,
  lastName: null,
  email: null,
  dateJoined: null,
  lastLogin: null,
  id: null,
  groups: null,
  isAuthenticated: false
};

export const identifyMappings = {
  [SET_USERDATA]: (getState, action) => {
    const {
      payload: { email, firstName, lastName, username }
    } = action;

    return {
      eventType: EventTypes.identify,
      eventPayload: {
        userId: email,
        traits: {
          email,
          firstName,
          lastName,
          username
        }
      }
    };
  }
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_USERDATA:
      return {
        username: action.payload.username,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        email: action.payload.email,
        dateJoined: action.payload.dateJoined,
        lastLogin: action.payload.lastLogin,
        id: action.payload.id,
        groups: action.payload.groups,
        isAuthenticated: state.isAuthenticated
      };
    case SET_IS_AUTHENTICATED:
      return {
        ...state,
        isAuthenticated: action.payload
      };
    default:
      return state;
  }
}

export const setUserData = data => {
  return {
    type: SET_USERDATA,
    payload: {
      username: data.username,
      firstName: data.first_name,
      lastName: data.last_name,
      email: data.email,
      dateJoined: data.date_joined,
      lastLogin: data.last_login,
      id: data.id,
      groups: data.groups
    }
  };
};

export const setIsAuthenticated = isAuthenticated => {
  return {
    type: SET_IS_AUTHENTICATED,
    payload: isAuthenticated
  };
};
